export const contactLinks = [
  {
    name: "Github",
    url: "https://img.icons8.com/doodle/40/000000/github--v1.png",
    link: "https://github.com/nick3948",
  },
  {
    name: "LinkedIn",
    url: "https://img.icons8.com/doodle/40/000000/linkedin--v2.png",
    link: "https://www.linkedin.com/in/nikhil-kumar-gattu-a315a1184/",
  },
];

export const techStack = {
  programming: [
    {
      name: "C++",
      link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg",
    },
    {
      name: "Java",
      link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
    },
    {
      name: "Python",
      link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg",
    },
    {
      name: "TypeScript",
      link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
    },
    {
      name: "Javascript",
      link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
    },
    {
      name: "SQL",
      link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg",
    },
    {
      name: "JSON",
      link: "https://cdn.jsdelivr.net/npm/simple-icons@v7/icons/json.svg",
    },
    {
      name: "HTML",
      link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
    },
    {
      name: "CSS",
      link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-plain.svg",
    },
  ],
  frameworks: [
    {
      name: "React",
      link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg",
    },
    {
      name: "Next.js",
      link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg",
    },
    {
      name: "NodeJS",
      link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original-wordmark.svg",
    },
    {
      name: "Django",
      link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/django/django-plain.svg",
    },
    {
      name: "Bootstrap",
      link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-plain.svg",
    },
    {
      name: "REST API",
      link: "https://img.icons8.com/external-flat-juicy-fish/60/external-api-coding-and-development-flat-flat-juicy-fish.png",
    },
    {
      name: "Machine Learning",
      link: "https://img.icons8.com/ios-filled/50/artificial-intelligence.png",
    },
  ],
  cloud: [
    {
      name: "AWS",
      link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-original-wordmark.svg",
    },
    {
      name: "S3",
      link: "https://img.icons8.com/color/48/amazon-s3.png", // Using a specific icon for S3 if available, or finding a suitable one. 
    },
    {
      name: "Azure",
      link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-plain.svg",
    },
    {
      name: "Docker",
      link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-plain.svg",
    },
    {
      name: "Postman",
      link: "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
    },
    {
      name: "Git",
      link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-plain.svg",
    },
    {
      name: "Figma",
      link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg",
    },
    {
      name: "GitHub Actions",
      link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg", // Using GitHub logo for Actions as a placeholder or specific if found.
    },
    {
      name: "Linux",
      link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linux/linux-original.svg",
    },
    {
      name: "VS Code",
      link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg",
    },
  ],
};

export const experiences = [
  {
    title: "Software Support Consultant",
    level: "Student Employee",
    company: "University Information & Technology, Service Desk",
    location: "Corvallis, OR, USA",
    duration: "July 2025 – Present",
    points: [
      "Providing first-line technical support to the OSU community via phone, email, and in-person.",
      "Troubleshooting hardware/software issues and Document support requests.",
      "Assisting in training new technicians and maintaining Service Desk workspaces.",
    ],
  },
  {
    title: "Software Engineer I",
    level: "Full-time",
    company: "Planon Software Services Pvt Ltd",
    location: "Hybrid — Hyderabad, India",
    duration: "Aug 2022 - Aug 2024",
    points: [
      "Developed and maintained Java-based backend services within a distributed enterprise platform.",
      "Built and integrated RESTful APIs for seamless data exchange with SAP systems.",
      "Optimized backend workflows, enhancing system performance and reliability.",
      "Collaborated with Agile teams to deliver features and resolve production issues.",
      "Mentored junior engineers on Planon customization strategies.",
    ],
  },
  {
    title: "Engineer Trainee",
    level: "Internship",
    company: "Planon Software Services Pvt Ltd",
    location: "On-site — Hyderabad, India",
    duration: "Sep 2021 - Jul 2022",
    points: [
      "Contributed to the development of Java-based backend services within a distributed enterprise architecture.",
      "Integrated SAP systems via RESTful APIs under the guidance of senior engineers.",
      "Assisted in optimizing SQL queries and backend workflows to enhance application performance.",
      "Debugged production issues, gaining valuable experience in enterprise-scale systems.",
    ],
  },
  {
    title: "Technical Content Writer",
    level: "Freelance",
    company: "GeeksForGeeks",
    location: "Remote — Hyderabad, India",
    duration: "Feb 2023 – Feb 2024",
    points: [
      "Authored and enhanced 25+ technical articles on Python, JavaScript, C++, Angular topics.",
      "Improved readability and technical clarity for a global audience.",
      "Met tight deadlines while maintaining high-quality educational content.",
    ],
  },
];
